// ModalRunInvoicingProcess.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { postWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";
import { useInvoicing } from "../invoiceContext";

const ModalRunInvoicingProcess = ({ onClose }) => {
  const invoicingContext = useInvoicing();
  const [isLoading, setIsLoading] = useState(false);
  const [localError, setLocalError] = useState("");

  const [processDate, setProcessDate] = useState("");
  const [invoiceId, setInvoiceId] = useState("");

  const handleRunProcess = async () => {
    setIsLoading(true);
    setLocalError("");

    // Validación: al menos uno de los dos
    if (!processDate && !invoiceId) {
      setIsLoading(false);
      setLocalError("Debes indicar una fecha o un ID de factura.");
      return;
    }

    // Montamos el payload según lo que haya rellenado el usuario
    const payload = {};
    if (processDate) {
      payload.process_date = processDate; // ajusta el nombre al backend
    }
    if (invoiceId) {
      payload.invoice_id = invoiceId; // ajusta el nombre al backend
    }

    try {
      const response = await postWithAuth(
        API_URLS.RUN_INVOICING_PROCESS,
        payload
      );

      if (response.message === "success") {
        invoicingContext.setAlertType("success");
        invoicingContext.setMessage(
          "Proceso de invoicing ejecutado correctamente"
        );
        invoicingContext.openAlertHeader();
        invoicingContext.changeApiSuccess(); // recargar listado
        onClose();
      } else {
        setLocalError(
          response.detail || "Ha ocurrido un error al ejecutar el proceso"
        );
      }
    } catch (error) {
      console.error("Error ejecutando proceso de invoicing:", error);
      setLocalError("Ha ocurrido un error al ejecutar el proceso");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={true} onHide={onClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Ejecutar Proceso de Invoicing</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-5">
          <p className="mb-2">
            Puedes ejecutar el proceso a partir de una <strong>fecha</strong> o
            para un <strong>ID de factura</strong> concreto.
          </p>
          <p className="text-muted mb-0">
            Si indicas ambos, se utilizarán los dos filtros a la vez.
          </p>
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Fecha de proceso</label>
          <input
            type="date"
            className="form-control form-control-solid"
            value={processDate}
            onChange={(e) => setProcessDate(e.target.value)}
          />
          <div className="form-text">
            Opcional. Por ejemplo, para procesar las facturas de ese día.
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">ID de factura</label>
          <input
            type="text"
            className="form-control form-control-solid"
            placeholder="Introduce un ID de factura"
            value={invoiceId}
            onChange={(e) => setInvoiceId(e.target.value)}
          />
          <div className="form-text">
            Opcional. Ejecuta el proceso solo para esta factura.
          </div>
        </div>

        {localError && (
          <div className="alert alert-danger mt-3">{localError}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleRunProcess}
          disabled={isLoading}
          data-kt-indicator={isLoading ? "on" : "off"}
        >
          <span className="indicator-label">Ejecutar proceso de invoicing</span>
          <span className="indicator-progress">
            Ejecutando...
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRunInvoicingProcess;
